export default {
  options: {
    none: 'Brak kodu promocyjnego',
  },
  buttons: {
    next: 'Dalej',
    back: 'Wstecz',
    skip: 'Pomiń',
  },
};
